// Third Party
import React from 'react';
import classNames from 'classnames';
import Nullable from '@/types/nullable';

type DefaultProps = {
  columns?: number;
  autoCol?: boolean;
};

type OtherProps = {
  className?: string;
  elements: Array<Nullable<JSX.Element>>;
  rows?: number;
};

type Props = DefaultProps & OtherProps;

const Grid = ({ className, elements, columns = 5, autoCol }: Props) => {
  const renderGridItems = () =>
    elements.map((element, index) => (
      <div key={index} className="grid-item">
        {element}
      </div>
    ));

  const columnStyle = {
    gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
  };

  const autoColStyle = {
    gridAutoColumns: 'minmax(0, 1fr)',
    gridAutoFlow: 'column',
  };

  return (
    <div className={classNames('grid', className)} style={autoCol ? autoColStyle : columnStyle}>
      {renderGridItems()}
    </div>
  );
};

export type GridProps = Partial<DefaultProps> & OtherProps;

export default Grid;
